import React, { useState } from 'react';
import './benefeciaryUnderMobNo.css';
import { setBeneficiaryData, updateAncService, updateChild } from '@store/actions/beneficiaryAction';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@store/reducers';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import { benef_const } from '@constants/beneficiaryConstant';
import { dateFormate } from '@constants/index';
import { prepareBeneficiaryImageForDisplay } from '@utils/childUtils';


interface TableProps {
    data: { abhaId: string; name: string; gender: string; dob: string; address: string; profile: any; kycVerified?: boolean | string; index?: number }[];
}

const TableComponent: React.FC<TableProps> = ({ data }) => {
    const [selectedRow, setSelectedRow] = useState<number | null>(null);
    const dispatch=useDispatch();
    const mobNumber=useSelector((state: RootState) => state.beneficiary.beneficiaryMobileNumber);
    const isChildRegistration = useSelector((state: RootState) => state.beneficiary.isChildRegistration);

    const handleRowUpdation = (item: { abhaId: string; name: string; gender: string; dob: string; address: string; profile: any; kycVerified?: boolean | string; index?: number }, difference: number) => {
        const checkValidation = isChildRegistration ? difference > benef_const.childMinimumAge : difference < benef_const.childMinimumAge;
        const errorMessage = isChildRegistration ? benef_const.childBeneficiaryMaxAgeErrorMessage : benef_const.childBeneficiaryRegisterErrorMessage;
        if(checkValidation){
            dispatch(updateAncService('beneficiarySelected', false));
            dispatch(updateAncService('isBneficaryChild', true));
            toast.error(errorMessage, {
                position: "top-center",
            });
            
        }
        else{
            dispatch(updateAncService('beneficiarySelected', true));
        dispatch(setBeneficiaryData([{
            name:item.name,
            abhaId:item.abhaId,
            gender:item.gender,
            dob:item.dob,
            mob:mobNumber.split(' ')[mobNumber.split(' ').length-1],
            address:item.address,
            profile:item.profile,
            kycVerified: item.kycVerified,
            index: item.index
        }]))
        }
    }

    const handleRowClick = async (item: { abhaId: string; name: string; gender: string; dob: string;address:string;profile:any; kycVerified?: boolean | string; index?: number }, index: number) => {
        const isKycVerified = item.kycVerified === true || item.kycVerified === 'true';
        
        if (!isKycVerified) {
            toast.error('This beneficiary cannot be selected as KYC verification is not completed.', {
                position: "top-center",
            });
            return;
        }
        
        setSelectedRow(index);
        if (isChildRegistration && item?.profile) {
            const convertPhotoToFormType = await prepareBeneficiaryImageForDisplay(item?.profile || '');
            dispatch(updateChild('childImageData', convertPhotoToFormType.formData))
        }
        
        if (!item.dob || item.dob === '') {
            dispatch(updateAncService('beneficiarySelected', true));
            dispatch(updateAncService('isBneficaryChild', false));
            dispatch(setBeneficiaryData([{
                name:item.name,
                abhaId:item.abhaId,
                gender:item.gender,
                dob:item.dob,
                mob:mobNumber.split(' ')[mobNumber.split(' ').length-1],
                address:item.address,
                profile:item.profile,
                kycVerified: item.kycVerified,
                index: item.index
            }]));
            return;
        }
        
        const dob = item.dob;
        let difference;
         if (dob.length === 4) {
            const currentYear = dayjs().year();
            difference = currentYear - parseInt(dob);
        } else {
            difference = dayjs().diff(dayjs(dob, dateFormate.dd_mm_yyyy), "year");
        }
 
        dispatch(updateAncService('isBneficaryChild', false));
        handleRowUpdation(item, difference)
    };

    return (
        <div style={{ overflow: "auto" }}>
            <table className="custom-table">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Gender</th>
                        <th>ABHA Number</th>
                        <th>DOB</th>
                    </tr>
                </thead>
                <tbody>
                    {data?.map((item, index) => {
                        const isKycVerified = item.kycVerified === true || item.kycVerified === 'true';
                        
                        return (
                            <tr
                                key={index}
                                onClick={() => handleRowClick(item, index)}
                                className={`${selectedRow === index ? 'selected' : ''} ${!isKycVerified ? 'disabled-row' : ''}`}
                                style={{
                                    cursor: !isKycVerified ? 'not-allowed' : 'pointer',
                                    opacity: !isKycVerified ? 0.5 : 1,
                                    backgroundColor: !isKycVerified ? '#f5f5f5' : 'transparent'
                                }}
                            >
                                <td>{item.name}</td>
                                <td>{item.gender}</td>
                                <td>{item.abhaId.replace("-", "")}</td>
                                <td>{item.dob}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default TableComponent;
